import ConfigurationRepository from "../domain/data/ConfigurationRepository";
import { ClassroomSizeConfig, FeederPatternConfig, FeederPatternImportResult, SchoolDirectoryBatchResult, SchoolDirectoryEntry, SeatLimitConfig, SiteConfigs } from "../domain/entities/Configs";

export default class MockPermissionRepository
  implements ConfigurationRepository
{
  getSiteConfigs(orgId: string, page: string): Promise<SiteConfigs[]> {
    throw new Error("Method not implemented.");
  }
  saveSiteConfigs(
    orgId: string,
    page: string,
    siteConfigs: SiteConfigs
  ): Promise<SiteConfigs> {
    throw new Error("Method not implemented.");
  }
  saveImage(orgId: string, fileName: string, file: File): Promise<Boolean> {
    throw new Error("Method not implemented.");
  }
  getImage(orgId: string, fileName: string): Promise<File> {
    throw new Error("Method not implemented.");
  }
  saveSeatLimitConfig(seatLimitConfig: SeatLimitConfig): Promise<SeatLimitConfig> {
    throw new Error("Method not implemented.");
  }
  getSeatLimitConfigs(orgId: string): Promise<SeatLimitConfig[]> {
    throw new Error("Method not implemented.");
  }
  saveClassroomSizeConfig(classroomSizeConfig: ClassroomSizeConfig): Promise<ClassroomSizeConfig> {
    throw new Error("Method not implemented.");
  }
  getClassroomSizeConfigs(orgId: string): Promise<ClassroomSizeConfig[]> {
    throw new Error("Method not implemented.");
  }
  saveFeederPatternConfig(feederPattern: FeederPatternConfig): Promise<FeederPatternConfig> {
    throw new Error("Method not implemented.");
  }
  getFeederPatternConfigs(orgId: string): Promise<FeederPatternConfig[]> {
    throw new Error("Method not implemented.");
  }
  deleteFeederPatternConfig(organizationId: string, feederPatternId: string): Promise<void> {
    throw new Error("Method not implemented.");
  }
  importFeederPatternConfigs(organizationId: string, configs: FeederPatternConfig[]): Promise<FeederPatternImportResult> {
    throw new Error("Method not implemented.");
  }
  getSchoolDirectory(organizationId: string): Promise<SchoolDirectoryEntry[]> {
    throw new Error("Method not implemented.");
  }
  saveSchoolDirectoryEntry(organizationId: string, entry: SchoolDirectoryEntry): Promise<SchoolDirectoryEntry> {
    throw new Error("Method not implemented.");
  }
  saveSchoolDirectoryBatch(organizationId: string, entries: SchoolDirectoryEntry[]): Promise<SchoolDirectoryBatchResult> {
    throw new Error("Method not implemented.");
  }
  deleteSchoolDirectoryEntry(organizationId: string, schoolId: string): Promise<void> {
    throw new Error("Method not implemented.");
  }
}
